import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Document, Page, Image } from 'react-pdf';
import FileViewer from 'react-file-viewer';
import { Grid } from '@material-ui/core';
import PDFViewer from './PDFViewer';

export default function FilePreview(props) {
  const onError = e => {
    // console.log(e, 'error in file-viewer');
  };
  const [numPages, setPageNumber] = React.useState();
  const pageNumber = 1;

  function onDocumentLoadSuccess({ numPages }) {
    setPageNumber(numPages);
  }

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
        <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
            <Grid item xs={12} >
          {props.filePreview.type !== 'pdf' ? (
              
                <img
              src={props.filePreview.fileName}
              alt={'preview'}
            //   style={{maxWidth: '50%', height: 'auto'}}
             className={"img-fluid "}
          
            />
           
          ) : (
            // <Document
            // file={{
            //   url: props.filePreview.fileName,
            //   httpHeaders: {
            //     'Authorization': `Bearer ${localStorage.jwtToken}`,
            //   },
            //   withCredentials: true,
            // }}
            //   onLoadSuccess={onDocumentLoadSuccess}
            // >
            //   <Page pageNumber={pageNumber} />
            // </Document>
            <PDFViewer filePreview={props.filePreview.file}/>
          )}
          
          </Grid>
        </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose} color="primary">
            Закрити
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
